import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import './vendor.css';
import './styles.css';
import { onDayCreateHoliday, buildTimeSlotsPanel } from './utils';

const FLATPICKR_SELECTOR = '[data-flatpickr]';
const BOUND_KEY = 'true';

let initialized = false;

export function initFlatpickr(): void {
    if (initialized) return;
    initialized = true;
    document.addEventListener('ui:update', () => mount(document));
}

function mount(scope: ParentNode): void {
    const elements = Array.from(scope.querySelectorAll<HTMLElement>(FLATPICKR_SELECTOR));
    elements.forEach((el) => {
        if (el.dataset.flatpickrBound === BOUND_KEY) return;
        el.dataset.flatpickrBound = BOUND_KEY;

        const customOptions = el.dataset.flatpickrOptions
            ? JSON.parse(el.dataset.flatpickrOptions)
            : {};

        const times: string[] = el.dataset.flatpickrTimes
            ? JSON.parse(el.dataset.flatpickrTimes)
            : [];

        const calendarTitle = el.dataset.flatpickrCalendarTitle ?? '';
        const slotsTitle = el.dataset.flatpickrSlotsTitle ?? '';
        const sideSlots = el.hasAttribute('data-flatpickr-side-slots');

        // 時間スロットがある場合、フォーム送信値を保持するhidden inputを作成
        let combinedInput: HTMLInputElement | null = null;
        if (times.length > 0 && el instanceof HTMLInputElement && el.name) {
            combinedInput = document.createElement('input');
            combinedInput.type = 'hidden';
            combinedInput.name = el.name;
            el.name = '';
            el.insertAdjacentElement('afterend', combinedInput);
        }

        flatpickr(el, {
            locale: Japanese,
            dateFormat: 'Y年m月d日',
            onReady(_dObj, _dStr, fp) {
                if (calendarTitle) {
                    const titleEl = document.createElement('div');
                    titleEl.className = 'flatpickr-calendar-title';
                    titleEl.textContent = calendarTitle;
                    fp.calendarContainer.prepend(titleEl);
                }

                if (times.length === 0) return;

                const { panel: slotsPanel } = buildTimeSlotsPanel(
                    times,
                    slotsTitle,
                    (time) => {
                        const dateStr =
                            fp.selectedDates.length > 0
                                ? fp.formatDate(fp.selectedDates[0], fp.config.dateFormat)
                                : '';
                        if (dateStr) {
                            fp.input.value = `${dateStr} ${time}`;
                            if (combinedInput) combinedInput.value = fp.input.value;
                        }
                    },
                );

                if (sideSlots) {
                    const calMain = document.createElement('div');
                    calMain.className = 'flatpickr-cal-main';
                    const months = fp.calendarContainer.querySelector('.flatpickr-months');
                    const inner = fp.calendarContainer.querySelector('.flatpickr-innerContainer');
                    if (months) calMain.appendChild(months);
                    if (inner) calMain.appendChild(inner);
                    const layout = document.createElement('div');
                    layout.className = 'flatpickr-layout';
                    layout.appendChild(calMain);
                    layout.appendChild(slotsPanel);
                    fp.calendarContainer.classList.add('flatpickr-calendar--side-slots');
                    fp.calendarContainer.appendChild(layout);
                } else {
                    fp.calendarContainer.appendChild(slotsPanel);
                }
            },
            onChange(_dObj, dateStr, fp) {
                if (times.length === 0) return;
                const selectedBtn = fp.calendarContainer.querySelector<HTMLButtonElement>(
                    '.flatpickr-time-slot.is-selected'
                );
                const time = selectedBtn?.dataset.time ?? times[0];
                if (dateStr) {
                    fp.input.value = `${dateStr} ${time}`;
                    if (combinedInput) combinedInput.value = fp.input.value;
                }
            },
            onDayCreate: onDayCreateHoliday,
            ...customOptions,
        });
    });
}
